import { LocationType } from '@/entities/location';
import { extractTagSlugFromRouteParam } from '@/entities/rubrics';

export function useListingRouteParams() {
  const route = useRoute();

  const getParam = <K extends keyof typeof route.params>(name: K): string => {
    const val = route.params[name];

    if (val == null) {
      return '';
    }

    const v = Array.isArray(val) ? val[0] : val;

    return v === 'iz' ? '' : String(v);
  };
  // Заполняем query параметр на основе местоположения из route
  const slug = computed(() => {
    const { countrySlug, regionSlug, citySlug } = route.params;

    // TODO рефакторинг, осмысленное приведение массивов
    if (Array.isArray(regionSlug)) {
      return regionSlug[0];
    }
    if (regionSlug) {
      return regionSlug;
    }
    if (Array.isArray(countrySlug)) {
      return countrySlug[0];
    }
    if (countrySlug) {
      return countrySlug;
    }
    if (Array.isArray(citySlug)) {
      return citySlug[0];
    }
    if (citySlug) {
      return citySlug;
    }

    return '';
  });

  const tagSlug = computed(() => {
    const { tag } = route.params;

    // TODO рефакторинг, почему tag может быть массивом и почему игнорируются другие параметры
    if (Array.isArray(tag)) {
      return extractTagSlugFromRouteParam(tag[0]);
    }

    if (tag) {
      return extractTagSlugFromRouteParam(tag);
    }

    return '';
  });

  // Создаем query параметр на основе местоположения из route
  const location = computed(() => {
    const { countrySlug, regionSlug } = route.params;

    if (regionSlug) {
      return LocationType.REGION;
    }
    if (countrySlug) {
      return LocationType.COUNTRY;
    }

    return LocationType.CITY;
  });

  const isLocation = computed(() => ({
    isCity: location.value === LocationType.CITY,
    isRegion: location.value === LocationType.REGION,
    isCountry: location.value === LocationType.COUNTRY,
  }));

  const isFromCityPage = computed(() => Boolean(route.meta?.isFromCityPage));

  const fromCitySeoPayload = computed(() => {
    if (!isFromCityPage.value) {
      return null;
    }

    const citySlug = getParam('citySlug') || getParam('city') || '';
    const regionSlug = getParam('regionSlug') || '';
    const countrySlug = getParam('countrySlug') || getParam('country') || '';

    if (regionSlug) {
      return { regionSlug, citySlug };
    }

    return { countrySlug, citySlug };
  });

  return {
    slug,
    tagSlug,
    location,
    isLocation,
    isFromCityPage,
    fromCitySeoPayload,
  };
}
